
const conceptBg = (() => {
  const pageConcept = (document.getElementById("pageConcept") != null);
  if (pageConcept) {



    const secConcept = document.getElementById('jsSecConcept');
    const bgWrap = secConcept.querySelector('.js-bg-wrap');
    const bgArea = bgWrap.querySelectorAll('.js-bg-area');
    const conceptWraps = secConcept.querySelectorAll('.js-concept-wrap');


    // pin
    // {
    //   let to = gsap.to(bgWrap, {
    //     ease: "none",
    //     scrollTrigger: {
    //       invalidateOnRefresh: true,
    //       trigger: bgWrap,
    //       start: 'top top',
    //       endTrigger: secConcept,
    //       end: 'bottom bottom',
    //       pin: true,
    //       // markers: true
    //     }
    //   })


    //   let target = document.querySelector('body');
    //   let observer = new ResizeObserver((entries) => {
    //     entries.forEach((entry) => {
    //       to.scrollTrigger.refresh()
    //       // console.log('comParallax refresh');
    //     });
    //   });
    //   observer.observe(target);
    // }


    // Bg Change
    {
      conceptWraps.forEach((element, index) => {

        let bgBox = bgArea[index].querySelector('.js-bg-box');

        let tl1 = gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: element,
            start: "0% 50%",
            onEnter: () => bgArea[index].classList.add('act'),
            // onLeave: () => console.log("onLeave"),
            // onEnterBack: () => console.log("onEnterBack"),
            onLeaveBack: () => bgArea[index].classList.remove('act'),
            // markers: true,
          },
        })

        // if (index == 0) {

        //   let bgBoxIntro1 = bgArea[index].querySelector('.js-img-box-intro-1');
        //   let bgBoxIntro2 = bgArea[index].querySelector('.js-img-box-intro-2');

        //   gsap.timeline({
        //     scrollTrigger: {
        //       invalidateOnRefresh: true,
        //       trigger: element,
        //       start: "5% 0%",
        //       onEnter: () => {
        //         bgBoxIntro1.classList.add('on')
        //         bgBoxIntro2.classList.add('off')
        //       },
        //       // onLeave: () => console.log("onLeave"),
        //       // onEnterBack: () => console.log("onEnterBack"),
        //       onLeaveBack: () => {
        //         bgBoxIntro1.classList.remove('on')
        //         bgBoxIntro2.classList.remove('off')
        //       },
        //       // markers: true,
        //     },
        //   })
        // }

        let tl2 = gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: element,
            start: "50% 50%",
            onEnter: () => bgBox.classList.add('act'),
            // onLeave: () => console.log("onLeave"),
            // onEnterBack: () => console.log("onEnterBack"),
            onLeaveBack: () => bgBox.classList.remove('act'),
            // markers: true,
          },
        })


        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            tl1.scrollTrigger.refresh()
            tl2.scrollTrigger.refresh()
          });
        });
        observer.observe(target);
      });
    }



    // const imgBoxIntro2 = bgWrap.querySelector('.js-img-box-intro-2');
    // const scrollArea = bgWrap.querySelector('.js-scroll-area');

    // // スタート
    // {
    //   setTimeout(() => {
    //     imgBoxIntro2.classList.add('act')
    //     setTimeout(() => {
    //       scrollArea.classList.add('act')
    //     }, 800);
    //   }, 1200);
    // }

  }
})()
export default conceptBg;